const TRANSFER_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/api/estimate-transfer/transfer-costx-to-quickbooks`;

export const handleCostXToQuickbooksFlow = async (syncFlow, masterConnectors) => {
  // Get connection IDs

  const token = localStorage.getItem('token');
  
  const { costXConnectionId, quickBooksConnectionId } = getConnectionIds(masterConnectors);
  
  // Use hardcoded values for projectId, revisionId, databookId, and realmId
  // In a production environment, these should come from configuration or UI
  const projectId = 'e7b799d3-ef99-4ff8-9123-32895ddf2e4c';
  const revisionId = 'bc20e276-35dd-472a-9602-8fdc09ac3f23';
  const databookId = '602268d0-cd86-43e6-83f6-16f09858a247';
  const realmId = '9341453766608919';
  
  // Construct the API URL
  const apiUrl = `${TRANSFER_API_URL}?costXConnectionId=${costXConnectionId}&quickBooksConnectionId=${quickBooksConnectionId}&projectId=${projectId}&revisionId=${revisionId}&databookId=${databookId}&realmId=${realmId}`;
  
  console.log('Executing CostX to QuickBooks transfer API:', apiUrl);
  
  // Call the transfer API
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    }
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  // Return the response data if needed
  return await response.json();
};

const getConnectionIds = (masterConnectors) => {
  // Find CostX connector
  const costXConnector = masterConnectors.find(connector => 
    connector.mcName === 'CostX');
  
  // Find Quickbook connector
  const quickbookConnector = masterConnectors.find(connector => 
    connector.mcName === 'Quickbook');
  
  const costXConnectionId = costXConnector ? costXConnector.mcRecId : 1;
  const quickBooksConnectionId = quickbookConnector ? quickbookConnector.mcRecId : 2;
  
  return { costXConnectionId, quickBooksConnectionId };
};